// Som de aviso para um pedido de reembolso novo.
//
// Gerado com a Web Audio API, e não com um ficheiro: não há nada para carregar,
// nada que falhe por um caminho errado num build, e o painel funciona offline
// da mesma maneira.
//
// **O browser não deixa tocar som antes de alguém mexer na página.** Um painel
// aberto de manhã e deixado sozinho na parede ficava mudo o dia inteiro, sem
// ninguém saber porquê. Por isso o contexto de áudio desbloqueia-se no primeiro
// clique ou tecla — que no TOMS é o próprio login — e fica pronto daí em diante.

let ctx = null;

const getContext = () => {
  if (ctx) return ctx;
  const AudioCtx = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
  if (!AudioCtx) return null;
  ctx = new AudioCtx();
  return ctx;
};

/** Liga o desbloqueio ao primeiro gesto do utilizador. Chamar uma vez, no arranque. */
export const unlockAudioOnFirstGesture = () => {
  if (typeof window === 'undefined') return;
  const unlock = () => {
    const c = getContext();
    if (c && c.state === 'suspended') c.resume().catch(() => {});
    window.removeEventListener('pointerdown', unlock);
    window.removeEventListener('keydown', unlock);
  };
  window.addEventListener('pointerdown', unlock);
  window.addEventListener('keydown', unlock);
};

// Três notas a subir, duas vezes. Diferente de tudo o resto que toca numa
// cozinha — um bip único confunde-se com o forno.
const NOTAS = [660, 880, 1100];
const DURACAO = 0.16;
const INTERVALO = 0.2;
const REPETICOES = 2;
const PAUSA = 0.5;

/** Toca o aviso. Silencioso (sem erro) se o browser não tiver áudio. */
export const playRefundAlert = () => {
  const c = getContext();
  if (!c) return;
  if (c.state === 'suspended') c.resume().catch(() => {});

  const inicio = c.currentTime + 0.05;
  for (let r = 0; r < REPETICOES; r += 1) {
    NOTAS.forEach((freq, i) => {
      const t = inicio + r * (NOTAS.length * INTERVALO + PAUSA) + i * INTERVALO;
      const osc = c.createOscillator();
      const gain = c.createGain();
      osc.type = 'sine';
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(0.4, t + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + DURACAO);
      osc.connect(gain).connect(c.destination);
      osc.start(t);
      osc.stop(t + DURACAO + 0.02);
    });
  }
};
